"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.ensureExecutableGraphQLSchema = ensureExecutableGraphQLSchema;
exports.unwrapType = unwrapType;

var _relayPagination = require("./relay-pagination");

var _graphql = require("graphql");

function capitalize(str) {
  return "".concat(str.charAt(0).toUpperCase()).concat(str.slice(1));
}

function ensureExecutableGraphQLSchema(graphQLSchema) {
  if (!(graphQLSchema instanceof _graphql.GraphQLSchema)) {
    if (typeof graphQLSchema === "string") {
      graphQLSchema = (0, _graphql.parse)(graphQLSchema);
    }

    graphQLSchema = (0, _graphql.buildASTSchema)(graphQLSchema, {
      commentDescriptions: true
    });
  }

  return graphQLSchema;
}

function unwrapType(type) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    considerRelay: false,
    isList: false
  };

  if (options.considerRelay && (0, _relayPagination.isRelayType)(type)) {
    var fields = type.getFields();
    return fields.edges ? unwrapType(fields.edges.type, options) : unwrapType(fields.node.type, options);
  }

  var isList = (0, _graphql.isListType)(type);

  if (isList || (0, _graphql.isNonNullType)(type)) {
    if (!options.isList) {
      options.isList = isList;
    }

    return unwrapType(type.ofType, options);
  }

  return {
    isList: options.isList,
    type: type
  };
}
